import styled, { css } from 'styled-components';

export const Container = styled.li`
    display: flex;
    min-width: 200px;
    height: 40px;
    flex-direction: row;
    justify-content: center;
    padding: .3rem;
    border-radius: 6px;
    background-color: #f6f6f6;
    border: solid 2px transparent;
    margin-bottom: 0.3rem;
    > div:nth-child(1){
        display: flex;
        width: 100%;
        align-items: center;
        padding: .3rem;
        height: 100%;
        > div {
            display: flex;
            height: 100%;
            text-align: center;
            font-weight: 500;
            color: #6c757d;
        };
        > div:nth-child(1){
            max-height: 2rem;
            width: 30%;
            > span {
                font-size: 10px;
                display: flex;
                max-height: 3rem;
                justify-content: center;
                align-items: center;
                padding: .3rem;
                min-width: 3rem;
                border-radius: 4px;
                color: #ffffff;
                font-weight: bolder;
                background-color:#1D86FF;
            }
        }
        > div:nth-child(2){
            display: flex;
            max-height: 100px;
            width: 100%;
            font-size: 10px;
            justify-content: center;
            align-items: center;
        }
    };
    > div:nth-child(2){
        display: flex;
        width: 20%;
        height: 2rem;
        justify-content: center;
        align-items: center;
        .opacity--{
            opacity: .1;
        };
        .faLockOpen{
            margin-left: 10px;
        }
    };
   
`;